import React from 'react'
import { useTranslation } from 'react-i18next'
import './Footer.css'

export default function Footer() {
  const { t } = useTranslation('shared') // 🌐 usamos el mismo namespace

  return (
    <footer className="footer-container">
      <p className="footer-text">
        © {new Date().getFullYear()} Rustaro - {t('allRightsReserved')}
      </p>
    </footer>
  )
}
